FamilycardsImageLibrary.controller('favoriteController', [ '$scope', '$http', function( $scope, $http ) {

	$scope.favoriteLoading = {};
	$scope.favorites = {};

	var protocol = window.location.protocol;
	var hostname = window.location.hostname;

	$scope.switchFavorite = function( $action, $id ) {

		$scope.favoriteLoading[$id] = true;

		$http({
			method: 'GET',
			url: protocol + '//' + hostname + '/api/beelden/' + $id + '/favorieten/' + $action,
		}).
		success( function( response, status, headers, config ) {
			$scope.favoriteLoading[$id] = false;
			$scope.favorites[$id] = response.isFavorite;
			jQuery('.favorite-holder').html('<span class="favorite-counter">' + response.count + '</div>');
		}).
		error(function(data, status, headers, config) {});
	}

}]);

function getCurrentApiUrl() {

	var path = window.location.pathname;
	var protocol = window.location.protocol;
	var hostname = window.location.hostname;

	if( path.substr( path.length - 1 ) != '/' ) {
		path = path + '/';
	}

	return protocol + '//' + hostname + '/api ' + path;

}
